export const FILE_INPUT = {
  BUTTON: 'Select file',
  DROP_LABEL: ' or drag & drop file here',
  REPLACE: 'Replace',
};
